<span class="inline-flex mr-1">
  <span class="px-1.5 py-[2px] rounded-full text-xs font-semibold text-nowrap inline-flex items-center gap-2"
      [ngClass]="color"
      [matTooltip]="tooltip"
      matTooltipClass="whitespace-pre-line wide-tooltip">
      {{ label | translate }}
      <span *ngIf="ping" class="relative flex size-1.5">
        <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-violet-100 opacity-75"></span>
        <span class="relative inline-flex size-1.5 rounded-full bg-violet-500"></span>
      </span>
  </span>
</span>
